import React from "react";
import { formatCurrency } from "common/helpers/DataFormat";
import { Accordion, Button, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import styles from './DossierDataTable.module.scss';
import { ExclamationTriangle } from "react-bootstrap-icons";
import {useDispatch, useSelector } from "react-redux";
import { FiletypePdf } from "react-bootstrap-icons";
import { FiletypeXml } from "react-bootstrap-icons";

export default function DossierDataTable(props){
    const {data,onButtonCallBack} = props;
    const lblSize = 4;
    const contrasenia = data.documents.filter((item, index)=>
        ((item.type == 20))
    );
    const {catalogs} =  useSelector((state)=> { 
        return state;
    });
    
    function switchStatus(){
        switch (data.status){
            case 0:case 1:case 2:{
                return <div className={styles.recibidovent}>RECIBIDO EN VENTANILLA</div>;
            }break;

            case 20:{
                return <div className={styles.recibidovent}>{data.LABEL_DOSSIER_STATUS}</div>;
            }break;
            default:{
                return <div className={styles.onprogressevent}>{data.LABEL_DOSSIER_STATUS}</div>;
            }break;
        }
    }
    if (catalogs.loading == true) return <div>Cargando ...</div>;
    return <Container><Container>
                <Row>
                    <Col><h1 className={styles.detailtitle}>{data.dossier_type_name} #{data.id}</h1> </Col>

                </Row>
                <Row>
                    <Col className={styles.labeldata} xs={lblSize}>Hora y fecha de recepción:</Col>
                    <Col>{data.reception_timestamp}</Col>
                </Row>
                <Row>
                    <Col className={styles.labeldata} xs={lblSize}>Estatus del trámite:</Col>
                    <Col>{switchStatus()}</Col>
                </Row>
                <Row>
                    <Col className={styles.labeldata} xs={lblSize}>Empresa:</Col>
                    <Col>{data.metadata.DOSSIER_ENTERPRISE.value} - {catalogs.enterprises.filter(doc => doc.erp_code1==data.metadata.DOSSIER_ENTERPRISE.value)[0].name}</Col>
                </Row>
                <Row>
                    <Col className={styles.labeldata} xs={lblSize}>{data.metadata.DOSSIER_NO_PEDIDO.label}:</Col>
                    <Col>{data.metadata.DOSSIER_NO_PEDIDO.value}</Col>
                </Row>
                {
                    (data.metadata.DOSSIER_NO_HOJA_ENTRADA.length>0)?
                        <Row>
                            <Col className={styles.labeldata} xs={lblSize}>{data.metadata.DOSSIER_NO_HOJA_ENTRADA[0].label}:</Col>
                            <Col>{data.metadata.DOSSIER_NO_HOJA_ENTRADA.map((he,idx)=>{
                                if ((idx+1) < data.metadata.DOSSIER_NO_HOJA_ENTRADA.length) return he.value+", ";
                                else return he.value;
                            })}</Col>
                        </Row>
                    :""
                }

            </Container>
            <br />
            <Accordion alwaysOpen={true} defaultActiveKey={["0","1","2"]}>
            {   (data.status>=250)?
                <Accordion.Item  eventKey="0">
                     <Accordion.Header><h3>Documentos de pago</h3></Accordion.Header>
                     <Accordion.Body>
        
                <Container>
                    
      
                        {   (contrasenia.length==0)?
                            "Pendiente de emisión de contraseña de pago"
                            :
                            
                           
                                            
                                <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Tipo de documento</th>
                                        <th scope="col">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th scope="row">
                                        1
                                    </th>
                                    <td>
                                    
                                                    {contrasenia[0].document_type_label}
                                    </td>
                                    <td>

                                        <Button className={styles.btnfel} variant="primary" onClick={()=> onButtonCallBack("PDF",{...contrasenia[0], allowReplace:true, variant:'contrasenia_pago', related_doc: null}) }><FiletypePdf /> Ver Contraseña de Pago</Button>                     
                                    
                                    </td>
                                </tr>
                                </tbody>
                                </table>
                                
                           
                        }
                    
                    
                </Container>

                </Accordion.Body>
                </Accordion.Item>
                :""
            }

            <Accordion.Item  eventKey="1">
                 <Accordion.Header><h3>Documentos recibidos</h3></Accordion.Header>
                <Accordion.Body>
                <h3>Documentos a pagar</h3>
                {
                   
                    data.documents.map((doc,idx)=>{
                        
                        if 
                        (
                            (
                                doc.type ==1
                            )
                            ||
                            (
                                doc.type==3
                            )
                            ||
                            (
                                doc.type == 17
                            )

                        )
                        {
                            let factXML = data.documents.filter((item, index)=>
                                ((item.type == 2)&&(item.section === doc.section))
                            );
                            let retenIVA = data.documents.filter((item, index)=>
                                ((item.type == 18)&&(item.section === doc.section))
                            );
                            let retenISR = data.documents.filter((item, index)=>
                                ((item.type == 19)&&(item.section === doc.section))
                            );

                        return  <Row key={idx}>
                                    <Col>
                                        <Container className={styles.onedoc}>
                                            <Row>
                                                <Col>
                                                    <h4 className={styles.doctitle}>{doc.document_type_label}</h4>
                                                </Col>
                                                <Col>
                                                <Button className={styles.btnfel} variant="outline-primary" onClick={()=> onButtonCallBack("PDF",doc) }><FiletypePdf /> Ver Documento</Button>&nbsp;
                                                {
                                                    ((doc.type===3))?
                                                        <div>
                                                            {
                                                                factXML.map((fitem,idx)=>{
                                                                    return <Button key={idx} className={styles.btnfel} variant="outline-primary" onClick={()=> onButtonCallBack("XML",fitem) }><FiletypeXml /> Ver XML</Button>;
                                                                })
                                                            }
                                                            &nbsp;
                                                        </div>
                                                        :''
                                                }
                                                {
                                                    (((doc.type===1)||(doc.type===3))&&(data.status>=250))?
                                                        <div>
                                                            
                                                            {
                                                    
                                                                retenISR.map((fitem,idx)=>{
                                                                    return <Button key={idx} className={styles.btnfel} variant="outline-primary" onClick={()=> onButtonCallBack("PDF",{...fitem, allowReplace:true, variant:'retencion_isr', related_doc: doc}) }><FiletypePdf /> Ver Retención ISR</Button>;
                                                                })
                                                            }
                                                                                                                     
                                                           
                                                        </div>
                                                    :""
                                                }</Col>
                                            </Row>
                                            <Row>
                                                <Col className={styles.labeldata} xs={lblSize}>
                                                    {doc.metadata.DOCUMENT_DATE.label}:
                                                </Col>
                                                <Col>
                                                    {doc.metadata.DOCUMENT_DATE.value}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className={styles.labeldata} xs={lblSize}>Serie y Número:</Col>
                                                <Col>{doc.serie}-{doc.numero}</Col>
                                            </Row>
                                            <Row>
                                                <Col className={styles.labeldata} xs={lblSize}>{
                                                    doc.metadata.DOCUMENT_MONTO.label
                                                }:
                                                </Col>
                                                <Col>{formatCurrency(doc.metadata.DOCUMENT_CURRENCY.value,doc.metadata.DOCUMENT_MONTO.value)}</Col>
                                            </Row>
                                            <Row>
                                                <Col className={styles.labeldata} xs={lblSize}>{doc.metadata.DOCUMENT_DESCRIPCION.label}</Col>
                                                <Col><div>{doc.description}</div></Col>
                                            </Row>
                                            
                                        </Container>
                                    </Col>
                            </Row>;
                        }else{
                            return;
                        }
                    })
                }

                { (data.status>=250)? <div>
                <h3>Retenciones de IVA</h3>
                <table className="table">
                    <thead>
                        <tr>
                            
                            <th scope="col">Tipo de documento</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        data.documents.map((doc,idx)=>{
                            
                            if ((doc.type==18)){
                            return  <tr key={idx}>
                                        
                                        <td>
                                        
                                                        {doc.document_type_label}
                                        </td>
                                        <td>
                                                        
                                           
                                        <Button className={styles.btnfel} onClick={()=> onButtonCallBack("PDF",{...doc,allowReplace:true,variant:'retencion_iva', related_doc: doc}) }><FiletypePdf /> Ver Documento</Button>
                                        

                                    </td>
                                </tr>;
                            }else{
                                return;
                            }
                        })
                    }
                   
                    </tbody>
                </table>
                </div>:''
                }

                </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item  eventKey="2">
                <Accordion.Header><h3>Documentos de soporte presentados</h3></Accordion.Header>
                <Accordion.Body>
               
                <table className="table">
                <thead>
                    <tr>
                        
                        <th scope="col">Tipo de documento</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                {
                    data.documents.map((doc,idx)=>{
                        
                        if ((doc.type>3)&&(!(doc.type>=17 && doc.type<=20))){
                        return  <tr key={idx}>
                                    
                                    <td>
                                    
                                                    {doc.document_type_label}
                                    </td>
                                    <td>
                                                    
                                    {(doc.status==4)?                    
                                        <Button className={styles.btnfel} onClick={()=> onButtonCallBack("PDF",doc) }><FiletypePdf /> Ver Documento</Button>
                                    :''}

                                </td>
                            </tr>;
                        }else{
                            return;
                        }
                    })
                }
                </tbody>
            </table>
            </Accordion.Body>
            </Accordion.Item>
            </Accordion>
            </Container>
   ;
}